import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { SHOP_URL } from '../../lib/constants';

const STORAGE_KEY = 'shopAnnouncementDismissed';

export const ShopAnnouncementBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = window.localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    window.localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-slate-900 text-white h-9 flex items-center justify-center text-sm"
      data-testid="shop-announcement-bar"
    >
      <a
        href={SHOP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-cyan-400 transition-colors"
      >
        Now ordering online — prescriptions, OTC and free delivery
      </a>
      <button
        onClick={handleDismiss}
        aria-label="Dismiss"
        className="absolute right-4 text-slate-400 hover:text-white transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
